import {trackSegmentEvent} from './trackSegmentEvent';

export function trackCancellationButtonClicks() {
  const cancellationButton = document.querySelector('a.button.cancel');
  if (!cancellationButton) {
    return;
  }

  cancellationButton.setAttribute('target', '_blank');
  cancellationButton.addEventListener('click', () => {
    trackSegmentEvent('Cancellation Requested', {
      'button_text': cancellationButton.textContent,
      'button_url': cancellationButton.href,
    });
  });
}
